import { ReduxStore } from 'store/types';

export const selectCurrentTime = (store: ReduxStore) => store.timer.currentTime;
